import React from 'react';
export function EditorListNumberIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1 5.173V9.5a.9.9 0 101.8 0V3.483c0-.98-1.185-1.471-1.878-.778L2.363 4.364a.9.9 0 001.273 1.272l.464-.463zM9 6a1 1 0 011-1h11a1 1 0 010 2H10a1 1 0 01-1-1zM9 12a1 1 0 011-1h11a1 1 0 010 2H10a1 1 0 01-1-1zM10 17a1 1 0 100 2h11a1 1 0 000-2H10zM3.804 15.405v-.002l.038-.06c.038-.057.096-.133.17-.207.151-.151.31-.236.488-.236.452 0 .6.149.6.6 0 .466-.291 1.108-.814 1.823-.497.681-1.099 1.287-1.49 1.652-.714.667-.274 1.925.756 1.925H6.5a.9.9 0 100-1.8H5.17c.193-.223.386-.463.57-.715.566-.775 1.16-1.815 1.16-2.885 0-.633-.163-1.274-.636-1.751-.475-.48-1.117-.649-1.764-.649-.823 0-1.414.416-1.762.764a3.181 3.181 0 00-.496.646c-.045.079-.497.869.355 1.295a.9.9 0 001.203-.394l.001-.001.002-.003v-.002z"
  }));
}